import { render, staticRenderFns } from "./GoldPriceBar.vue?vue&type=template&id=8b8c772a&scoped=true"
import script from "./GoldPriceBar.vue?vue&type=script&lang=js"
export * from "./GoldPriceBar.vue?vue&type=script&lang=js"
import style0 from "./GoldPriceBar.vue?vue&type=style&index=0&id=8b8c772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8c772a",
  null
  
)

export default component.exports